module.exports = __webpack_public_path__ + "img/tabbar1.6e5beb18.svg";